<app-service-view (delete)="delete.emit($event)" [program]="program">
  <div [formGroup]="form">
    @if(durationType == FormatTimeDataTypeEnum.by_duration && user) {
    <app-datepicker-input
      formControlName="startDate"
      label="start_date"
      inputId="startDate"
      icon="bi-calendar-check"
      [required]="true"
    />
    }

    @if(user) {
    <div class="input-group">
      <span class="input-group-text">
        <i class="bi bi-pencil"></i>
      </span>
      <div class="form-floating">
        <textarea
          type="note"
          class="form-control"
          id="note"
          formControlName="note"
          placeholder="{{ 'note' | transloco }}"
        ></textarea>
        <label for="note">{{ 'note' | transloco }}</label>
      </div>
    </div>
    }
  </div>
</app-service-view>
